import React from 'react';
import { tFallback } from './utils';
import { Button, Message, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import UploadFileZone from '../../../../components/upload/uploadFileZone';
import css from './imports-steps.module.css';

export const FileStep = ({
    typeKeys = ['attendees'],
    uploadModel,
    organization,
    event = null,
    disabled = false,
    blockContinue = false,
    requestPayload = {},
    fileName,
    defaultFormData = {},
    form,
    setForm,
    setFormObject,
    onCardDone,
    onDelete = () => {},
    onUpload = () => {},
    setUploadSuccess = () => {},
    children
}) => {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const getUrlParams = React.useCallback(
        file => {
            const params = {
                datas: { step_name: 'creation', ...requestPayload },
                name: file?.name?.split('.')[0]
            };
            if (event) {
                params['eventId'] = event.pk;
            }
            return params;
        },
        [event]
    );

    const handleDownload = React.useCallback(() => {
        const link = document.createElement('a');
        link.download = fileName;
        link.href = `/ticket/static/${fileName}`;
        link.click();
    }, [fileName]);

    const isDisabled = React.useMemo(() => disabled || blockContinue || (Array.isArray(form.file) && !form.file.length) || !form.importRequest, [form, disabled, blockContinue]);

    return (
        <div className={css['step-body']}>
            {children}
            <div className={css['step-upload-block']}>
                <div>{t(tFallback(typeKeys, type => `ticket.${type}.imports.steps.file.upload.label`))}</div>
                <UploadFileZone
                    fileTypes={['.xlsx']}
                    file={form.file?.path}
                    organization={organization}
                    customErrors={
                        <Message className={css['file-error-message']} title={t('nacre.ImportController.analysis.header.error')} type="danger">
                            {t('ticket.charts.newZone.fileError.seatMap', {
                                format: '.xlsx'
                            })}
                        </Message>
                    }
                    onError={() => {
                        setFormObject({ ...form, file: [], importRequest: [], requestDatas: {} });
                        toast.error(t('ticket.common.toast_error'));
                    }}
                    onDelete={() => {
                        setFormObject({ ...form, file: [], importRequest: [], requestDatas: {}, ...defaultFormData });
                        setUploadSuccess(false);
                        onDelete();
                    }}
                    onSelect={file => {
                        setForm('file', file);
                    }}
                    onUpload={resp => {
                        setUploadSuccess(true);
                        setForm('importRequest', resp);
                        onUpload(resp);
                    }}
                    getURLParams={getUrlParams}
                    uploadConfigModel={uploadModel}
                    labelDropzone={t(tFallback(typeKeys, type => `ticket.${type}.imports.steps.file.upload.description`))}
                />
            </div>
            <div className={css['step-footer']}>
                <Button primary inverted label={t(tFallback(typeKeys, type => `ticket.${type}.imports.steps.file.upload.template`))} onClick={handleDownload} />
                <Button className={css['step-cta']} primary label={t('ticket.common.action.continue')} onClick={onCardDone} disabled={isDisabled} />
            </div>
        </div>
    );
};
